export default __webpack_public_path__ + "static/media/agencySummary.f98b77f5.svg";